<template>
  <div v-if="state.visible" class="state-overlay" :class="positionClass">
    <div class="state-box">
      <img
        v-if="state.type === 'loading'"
        src="/img/loader.gif"
        class="loader-img"
      />

      <h4 v-if="state.title" class="mt-3">
        {{ state.title }}
      </h4>

      <p v-if="state.message" class="text-muted">
        {{ state.message }}
      </p>

      <button
        v-if="state.type === 'error' && state.retry"
        class="btn btn-primary mt-3"
        @click="onRetry">
        Retry
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "ErrorComponentNew",

  data() {
    return {
      // 🔥 single source of truth
      state: {
        visible: false,
        type: "loading",   // loading | error | info
        title: "",
        message: "",
        retry: false,
        position: "center", // center | top | bottom
      },
    };
  },

  computed: {
    positionClass() {
      return `state-${this.state.position}`;
    },
  },

  methods: {
    /* ----------------------------------
     * BACKWARD-COMPATIBLE METHODS
     * (same usage as old ErrorComponent)
     * ---------------------------------- */

    updateFormLoader(show) {
      if (show) {
        this.showLoading({
          title: "Loading",
          message: "Please wait...",
        });
      } else {
        this.hide();
      }
    },

    updateListLoader(show) {
      if (show) {
        this.showLoading({
          title: "Loading",
          message: "Fetching list...",
        });
      } else {
        this.hide();
      }
    },

    setError(title, message, retry = true) {
      this.state = {
        visible: true,
        type: "error",
        title,
        message,
        retry,
        position: "center",
      };
    },

    setInfo(title, message) {
      this.state = {
        visible: true,
        type: "info",
        title,
        message,
        retry: false,
      };
    },

    /* ----------------------------------
     * FUTURE-STICK INTERNAL API
     * ---------------------------------- */

    showLoading({ title = "", message = "", position = "center" } = {}) {
      this.state = {
        visible: true,
        type: "loading",
        title,
        message,
        retry: false,
        position,
      };
    },

    hide() {
      this.state.visible = false;
    },

    onRetry() {
      this.hide();
      this.$emit("retry");
    },
  },
};
</script>

<style scoped>
.state-overlay {
  position: absolute;
  inset: 0;
  background: rgba(255, 255, 255, 0.85);
  z-index: 50;

  display: flex;
  align-items: center;
  justify-content: center;
}

/* no matter how long the page is, overlay covers all 

.state-overlay {
  position: fixed;          /* KEY CHANGE 
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;

  background: rgba(255, 255, 255, 0.85);
  z-index: 9999;

  display: flex;
  align-items: center;
  justify-content: center;
} 
*/
/* DEFAULT (current behavior) */
.state-center {
  align-items: center;
}

/* TOP CENTER */
.state-top {
  align-items: flex-start;
  padding-top: 15%;
}

/* BOTTOM CENTER */
.state-bottom {
  align-items: flex-end;
  padding-bottom: 20px;
}

.state-box {
  text-align: center;
}

.loader-img {
  width: 48px;
}
</style>
